import React from 'react';
import { styled, SvgIcon, Chip } from '@teko/ui';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const StyledIcon = styled(SvgIcon)(({ theme }) => `
    margin-left: 0.25rem;
    --button-icon-color: ${theme == null ? void 0 : theme.brand.primary};
  `);
const StyledChip = styled(Chip)(({ theme }) => `
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
  background: ${theme == null ? void 0 : theme.brand.tertiary} !important;
  color: ${theme == null ? void 0 : theme.brand.primary};
  border: 1px solid  ${theme == null ? void 0 : theme.brand.primary};
`);
const ActivatedFilters = ({
  activeValues,
  onClick
}) => {
  if (!activeValues.length)
    return null;
  return /* @__PURE__ */ React.createElement(Wrapper, null, activeValues.map((option) => /* @__PURE__ */ React.createElement(StyledChip, {
    onClick: () => onClick && onClick(option),
    key: option.optionCode
  }, /* @__PURE__ */ React.createElement("span", null, option.optionName), /* @__PURE__ */ React.createElement(StyledIcon, {
    name: "close",
    size: 10
  }))));
};

export { ActivatedFilters };
